import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { SelectInput } from '@italia/components';
import { TextFilter } from '@italia/components/ItaliaTheme/Blocks/Common/SearchFilters';
import { Button } from 'design-react-kit/dist/design-react-kit';

const messages = defineMessages({
  find: {
    id: 'find',
    defaultMessage: 'Cerca',
  },
  search_keyword: {
    id: 'ambulatorio_search_keyword',
    defaultMessage: 'Cerca per nome',
  },
  comune: {
    id: 'ambulatorio_comune',
    defaultMessage: 'Comune',
  },
  distretto: {
    id: 'ambulatorio_distretto',
    defaultMessage: 'Distretto',
  },
});

const SearchBar = ({ filters, setFilters, options, doRequest }) => {
  const intl = useIntl();

  return (
    <div className="search-bar rounded bg-light py-3 px-4 mb-4 mr-lg-4 ml-lg-4">
      <form
        className="d-flex search-container align-items-center justify-content-center flex-wrap"
        onSubmit={(event) => {
          event.preventDefault();
          doRequest({ page: 1 });
        }}
      >
        {/* parent_title o searchableText ? */}
        <TextFilter
          id="parent_title"
          value={filters['parent_title'] ?? ''}
          placeholder={intl.formatMessage(messages.search_keyword)}
          onChange={(id, value) => {
            setFilters({
              ...filters,
              [id]: value,
            });
          }}
        />
        <div className="my-2 my-lg-1 mr-lg-3 filter-wrapper select-filter">
          <SelectInput
            id="circoscrizione"
            value={filters['circoscrizione'] ?? ''}
            placeholder={intl.formatMessage(messages.distretto)}
            onChange={(opt) => {
              setFilters({ ...filters, circoscrizione: opt });
            }}
            options={options?.circoscrizione ?? []}
            isClearable={true}
            isSearchable={true}
          />
        </div>
        <div className="my-2 my-lg-1 mr-lg-3 filter-wrapper select-filter">
          <SelectInput
            id="comune"
            value={filters['city'] ?? ''}
            placeholder={intl.formatMessage(messages.comune)}
            onChange={(opt) => {
              setFilters({ ...filters, city: opt });
              // checkClearComune(opt);
            }}
            options={options?.city ?? []}
            isClearable={true}
            isSearchable={true}
          />
        </div>

        <Button color="tertiary" icon={false} tag="button">
          {intl.formatMessage(messages.find)}
        </Button>
      </form>
    </div>
  );
};

export default SearchBar;
